module.exports = __webpack_public_path__ + "static/media/Sokk.67db8b93.PNG";